/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUsersWithoutReferrerResponseItem } from './search-users-without-referrer-response-item';


export interface SearchUsersWithoutReferrerResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchUsersWithoutReferrerResponseItem> | null;
}

